import { PUBLIC_APP_ENV } from '$app/env/public';

export const CONFIG = Object.freeze({
	NEXT_PUBLIC_PROMPT_SIGNIN_AFTER_ARTICLE_READS: 0 as number,
	// Amplify v6 config shape: the user pool lives under `Auth.Cognito`, and the
	// v5 `region` / `userPoolWebClientId` keys no longer exist (the region is
	// derived from `userPoolId`, and the client id is `userPoolClientId`).
	AMPLIFY: (() => {
		switch (PUBLIC_APP_ENV) {
			case 'production':
				return {
					Auth: {
						Cognito: {
							userPoolId: 'eu-west-1_CkkeITUvG',
							userPoolClientId: '40n7uu85t5qebhim2beo8ij7o2',
						},
					},
				};

			case 'staging':
				return {
					Auth: {
						Cognito: {
							userPoolId: 'eu-west-1_TxupjmbTP',
							userPoolClientId: '5am4bo5kgdqetavsbbd5pubchj',
						},
					},
				};

			default:
				return {
					Auth: {
						Cognito: {
							userPoolId: 'eu-west-1_pSl8L9hCb',
							userPoolClientId: '3kgbd58q72d2pt16bqbru1iaei',
						},
					},
				};
		}
	})(),
});

/**
 * Where Amplify records the currently signed-in user (its default storage is
 * `localStorage`). Shared between `hasStoredCognitoSession` and the pre-paint
 * inline script in NewsLayout so the two can never check different keys.
 */
export const COGNITO_LAST_AUTH_USER_KEY = `CognitoIdentityServiceProvider.${CONFIG.AMPLIFY.Auth.Cognito.userPoolClientId}.LastAuthUser`;

/**
 * Attribute stamped on <html> by the pre-paint probe in NewsLayout when a
 * Cognito session is stored, and removed once the restore settles. CSS in
 * NewsSavedTags hides the saved-tags bar while it is present, so the
 * server-rendered default tags are never painted at a signed-in visitor.
 * The selector in that CSS must stay in sync with this value.
 */
export const NEWS_RESTORING_SESSION_ATTR = 'data-news-restoring-session';
